"use client";

import { trackSevenDayStreak } from "@/lib/analytics/google-ads-tracking";
import { supabase } from "@/lib/supabaseClient";
import { createPracticeClient } from "@/shared/practice-client";
import { deviceTimezone } from "@/shared/streak";

export const practiceClient = createPracticeClient({
  source: "web",
  lock: (key, work) => (navigator.locks ? navigator.locks.request(key, work) : work()),
  read: async (key) => localStorage.getItem(key),
  write: async (key, value) => {
    localStorage.setItem(key, value);
  },
  request: async (userId, activity) => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session || session.user.id !== userId) throw new Error("Account changed");
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`/api/streak?timezone=${encodeURIComponent(deviceTimezone())}`, {
        signal: controller.signal,
        method: activity ? "POST" : "GET",
        cache: "no-store",
        headers: {
          Authorization: `Bearer ${session.access_token}`,
          "Content-Type": "application/json",
        },
        body: activity ? JSON.stringify(activity) : undefined,
      });
      if (!response.ok) throw new Error("Streak request failed");
      return await response.json();
    } finally {
      clearTimeout(timeout);
    }
  },
  milestone: (days) => {
    if (days === 7) trackSevenDayStreak({ streak_days: 7 });
  },
});

/** Exercise surfaces without a streak display use the same account-checked writer. */
export async function recordWebPractice(timestamp = Date.now()) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (session) await practiceClient.record(session.user.id, timestamp);
}
